import styled from '@emotion/styled';

export const SectionWrapper = styled.div(() => ({
  display: 'flex',
  padding: 10,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 15,
  alignSelf: 'stretch',
}));

export const Item = styled.div(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 20,
  width: '100%',
}));

export const ItemName = styled.div((props) => ({
  width: 170,
  minWidth: 150,
  color: props.theme.colors.inactive,
  fontSize: 13,
  fontWeight: 400,
}));

export const ItemValue = styled.div(() => ({
  fontSize: 13,
  fontWeight: 400,
}));

export const SecondaryItemValue = styled(ItemValue)(({ theme }) => ({
  fontFamily: theme.fonts.secondary,
  fontSize: 14,
}));

export const Spacer = styled.span(() => ({
  margin: '0 4px',
}));
